import { Injectable } from '@angular/core';
import { EmployeeService } from '../../employee/services/employee.service';
import { LeaveModel } from '../entities/LeaveModel';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { map, filter } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TaskSaveService } from '../../task/services/task-save.service';
import { ActuationService } from '../../employee-view/services/actuation.service';
import { LeaveUpdateModel } from 'app/modules/employee-view/entities/LeaveUpdateModel';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { RestResponse as GenericRestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { LeaveDetailModel } from 'app/modules/employee-view/entities/LeaveDetailModel';
import { ApiCallsHelper } from 'app/modules/common/helpers/ApiCallsHelper';
import { TaskSaveModel } from 'app/modules/task/entities/TaskSaveModel';
import { PendingTask } from 'app/modules/employee-view/actuaciones/create-actuationes/pending-task/pending-task.component';

export type ChangeLeaveTypeModel = {
    leaveType: string;
    nextTask: TaskSaveModel;
    pendingTasks: PendingTask[];
};

@Injectable({providedIn:'root'})
export class LeaveService {
    private LeaveDetailSubject = new BehaviorSubject(null);
    private LeavesSubject = new BehaviorSubject(null);

    private NoLeaveSubject = new BehaviorSubject(false);

    private LeavesSubscription: Subscription;

    public LeaveList: Array<LeaveModel>;
    public IsLeavesLoading: boolean;
    public SelectedRowId;
    public employeeId: number;
    public leaveColumns: any[];
    // HAVE TO CHECK THIS
    public HasActiveLeave = false;

    constructor(
        private apiService: ApiService,
        private employeeService: EmployeeService,
        private taskService: TaskSaveService,
        private actuationService: ActuationService
    ) {}

    GetEmployeeLeaves(employeeId: number): Observable<RestResponse> {
        this.IsLeavesLoading = true;
        return this.employeeService.getEmployeeDetails(employeeId).pipe(
            map((array) => {
                return array.result.map((element) => {
                    let fromDate;
                    let toDate;
                    if (element.Fbaja !== null) {
                        fromDate = element.Fbaja.split('T')[0];
                    }
                    if (element.Falta !== null) {
                        toDate = element.Falta.split('T')[0];
                    } else {
                        toDate = DateHelper.getUTCDateString(new Date());
                    }
                    if(fromDate !=undefined)
                    {
                        let dateDiff = DateHelper.getDateDifference(
                            fromDate,
                            toDate
                        );
                        dateDiff = Math.round(dateDiff) + 1;
                        return new LeaveModel(
                            element.id,
                            element.Tipo,
                            element.Fbaja,
                            element.Falta,
                            dateDiff,
                            element.Justificada
                        );
                    }
                    
                });
            })
        );
    }

    public PublishLeaves(employeeId: number): void {
        this.employeeId = employeeId;
        this.GetEmployeeLeaves(employeeId).subscribe(
            (res) => {
                this.LeavesSubject.next(res);
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public SubscribeLeaves(): void {
        const LeaveId = localStorage.getItem('LeaveID');
        this.LeavesSubscription = this.LeavesSubject.asObservable()
            .pipe(filter((val) => val !== null))
            .subscribe(
                (res) => {
                    this.LeaveList = res;
                    if (this.LeaveList && this.LeaveList.length > 0) {
                        if (!this.SelectedRowId) {
                            this.SelectedRowId =
                                this.LeaveList.length > 0
                                    ? this.LeaveList[0].Id
                                    : -1;
                            if (LeaveId !== null) {
                                this.SelectedRowId = LeaveId;
                            }
                        } else {
                            const index = this.LeaveList.findIndex((x) => {
                                // return x.Id === this.SelectedRowId;
                                this.SelectedRowId = LeaveId;
                            });
                            if (index === -1) {
                                this.SelectedRowId = this.LeaveList[0].Id;
                                if (LeaveId !== null) {
                                    this.SelectedRowId = LeaveId;
                                }
                            }
                        }
                    }

                    if (this.SelectedRowId !== -1) {
                        this.PublishEmployeeLeaveDetails(
                            this.SelectedRowId,
                            this.employeeId
                        );
                        this.employeeService.InitEmployeeWarning(this.employeeId, this.SelectedRowId);
                        this.taskService.PublishTasks(this.SelectedRowId);
                        this.actuationService.PublishActuations(
                            this.SelectedRowId
                        );
                    } else {
                        this.NoLeaveSubject.next(true);
                    }

                    this.IsLeavesLoading = false;
                    this.HasActiveLeave =
                        this.LeaveList.filter((e) => e.FBaja && !e.FAlta)
                            .length > 0;
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    PublishEmployeeLeaveDetails(leaveId: number, employeeId: number): void {
        const bajaObj = {
            employeeId: employeeId,
            leaveId: leaveId ? leaveId : 0,
        };

        let url = `${API.Leave.getBaja}`;

        url = url
            .replace('{employeeId}', bajaObj.employeeId.toString())
            .replace('{leaveId}', bajaObj.leaveId.toString());
        this.apiService.get(url).subscribe(
            (resp) => {
                this.LeaveDetailSubject.next(resp);
            },
            (error) => {
                console.error(error);
            }
        );
    }

    SubscribeEmployeeLeaveDetails(): Observable<any> {
        return this.LeaveDetailSubject.asObservable();
    }

    UnsubscribeLeaves(): void {
        this.LeavesSubscription.unsubscribe();
    }

    GetLeaveTypes(): Observable<RestResponse> {
        const url = `${API.LeaveType.getLeaveTypes}`;
        return this.apiService.get(url);
    }

    GetManagedUnmanagedLeaveTypes(companyId: number): Observable<RestResponse> {
        let url = `${API.LeaveType.getManagedUnmanagedLeaveTypes}`;
        url = url.replace('{companyId}', String(companyId));
        return this.apiService.get(url);
    }

    GetLeaveType(leaveType: string): Observable<RestResponse> {
        let url = `${API.Leave.LeaveType}`;
        url = url.replace('{leaveType}', leaveType);
        return this.apiService.get(url);
    }

    public UpdateLeave(
        leaveUpdateModel: LeaveUpdateModel
    ): Observable<RestResponse> {
        const url = `${API.Leave.updateLeave}`;
        return this.apiService.put(url, leaveUpdateModel);
    }

    public GetLeaveById(leaveId: string): Observable<RestResponse> {
        let url = `${API.Leave.LeaveById}`;
        url = url.replace('{leaveId}', leaveId);
        return this.apiService.get(url);
    }
    public UpdateBajaPrioritaria(bajaid: string,status:string): Observable<RestResponse> {
        let url = `${API.Leave.UpdateBajaPrioritaria}`;
        url = url.replace('{bajaid}', bajaid);
        url = url.replace('{status}', status);
        return this.apiService.put(url);
    }

    public ReabrirBaja(leaveId: string): Observable<RestResponse> {
        let url = `${API.Leave.reabrirBaja}`;
        url = url.replace('{leaveId}', leaveId);
        return this.apiService.put(url);
    }

    public UpdateLeaveMarca(
        leaveId: number,
        marcas: any
    ): Observable<RestResponse> {
        let url = `${API.Leave.updateLeaveMarca}`;
        url = url.replace('{leaveId}', String(leaveId));
        return this.apiService.put(url, marcas);
    }

    public GetAccidentLocations(employeeId: string): Observable<RestResponse> {
        let url = `${API.Leave.getAccidentList}`;
        url = url.replace('{employeeId}', employeeId);
        return this.apiService.get(url);
    }

    public GetLeaveListForValidations(
        employeeId: string
    ): Observable<RestResponse> {
        let url = `${API.Leave.getBajaDataByEmppId}`;
        url = url.replace('{EmployeeId}', employeeId);
        return this.apiService.get(url);
    }

    public GetLeaveObservation(leaveId: number): Observable<RestResponse> {
        let url = `${API.Leave.getLeaveObservation}`;
        url = url.replace('{leaveId}', String(leaveId));
        return this.apiService.get(url);
    }

    /**
     * Delete leave
     * @param leaveId Leave ID
     * @param motivo Reason to delete leave
     */
    public DeleteLeave(
        leaveId: number,
        motivo: string
    ): Observable<RestResponse> {
        const url = (API.Leave.deleteLeave as string)
            .replace('{leaveId}', String(leaveId))
            .replace('{motivo}', String(motivo));

        return this.apiService.delete(url);
    }



    /**
     * Pasar a baja
     */
    public pasarBaja(
        bajaId: number,
        trabajadorId: number
    ): Observable<GenericRestResponse<null>> {
        let url = (API.Leave.pasarBaja as string)
            .replace('{bajaId}', bajaId.toString())
            .replace('{trabajadorId}', trabajadorId.toString());
        return this.apiService.post(url);
    }

    /**
     * Toggle marc of a leave and returns the full marcus text back
     */
    public async toggleMarca(
        leave: LeaveDetailModel,
        mark: string,
        turnOn: boolean
    ): Promise<string> {
        let marcaString = '';

        if (leave.Marcas !== null) {
            marcaString = String(leave.Marcas);
        }

        if (turnOn) {
            marcaString = marcaString.concat(mark);
        } else {
            marcaString = marcaString.replace(mark, '');
        }

        const sub: Observable<GenericRestResponse<boolean>> =
            this.UpdateLeaveMarca(leave.LeaveId, { marcas: marcaString });
        const res = await ApiCallsHelper.toPromise(sub);

        if (res) {
            return marcaString;
        } else {
            throw new Error('Unknown error occured while updating leave marca');
        }
    }

    /**
     * Change leave type
     */
    public changeLeaveType(
        leaveId: number,
        changeLeaveTypeModel: ChangeLeaveTypeModel
    ): Observable<GenericRestResponse<null>> {
        const url = (API.LeaveType.changeLeaveType as string).replace(
            '{leaveId}',
            leaveId.toString()
        );

        return this.apiService.post(url, changeLeaveTypeModel);
    }
}
